import React from 'react';
import { Card, Button, Form, Row, Col, Modal } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { HOCPHANBOSUNG_API } from '../../../../utils/apiUrl';
import { Post } from '../../../../utils/httpProvider';
import DocumentInput from '../../../../components/document-input/DocumentInput';
import { trangThaiHocBoSungValue } from '../../../../utils/define';

const schema = yup.object().shape({
    tenHocPhan: yup.string().required('Vui lòng nhập tên học phần')
});

const HocPhanBoSungAdd = ({ hoSoId, setViewMode, refreshList }) => {
    const queryClient = useQueryClient();

    const addFunc = useMutation((value) => Post(HOCPHANBOSUNG_API.CREATE, null, value, false));

    const handleCreate = (values, { setSubmitting }) => {
        const requestData = {
            HoSoNghienCuuSinhId: hoSoId,
            TenHocPhan: values.tenHocPhan,
            NgayBatDau: values.ngayBatDau || null,
            SoHocPhan: values.soHocPhan ? Number(values.soHocPhan) : null,
            DiemSo: values.diemSo ? Number(values.diemSo) : null,
            FileCongVan: values.fileCongVan || '',
            FileKetQua: values.fileKetQua || '',
            TrangThai: trangThaiHocBoSungValue.chuaHoc
        };

        addFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204)) {
                    toast.success('Thêm mới thành công');
                    queryClient.invalidateQueries(['hocPhanBoSungData', hoSoId]);
                    queryClient.invalidateQueries(['duyetHocPhanBoSungData', hoSoId]);
                    if (refreshList) {
                        refreshList();
                    }
                    setViewMode('list');
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Thêm mới Học phần bổ sung</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={handleCreate}
                    initialValues={{
                        tenHocPhan: '',
                        ngayBatDau: '',
                        soHocPhan: '',
                        diemSo: '',
                        fileCongVan: '',
                        fileKetQua: ''
                    }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Tên học phần <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="tenHocPhan"
                                            value={values.tenHocPhan}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.tenHocPhan && !!errors.tenHocPhan && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.tenHocPhan}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Ngày bắt đầu</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="ngayBatDau"
                                            value={values.ngayBatDau}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Số tín chỉ</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="soHocPhan"
                                            value={values.soHocPhan}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Điểm số</Form.Label>
                                        <Form.Control
                                            type="number"
                                            step="0.01"
                                            name="diemSo"
                                            value={values.diemSo}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <DocumentInput
                                            labelTitle="File công văn"
                                            value={values.fileCongVan}
                                            onChangeProp={(url) => setFieldValue('fileCongVan', url)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <DocumentInput
                                            labelTitle="File kết quả"
                                            value={values.fileKetQua}
                                            onChangeProp={(url) => setFieldValue('fileKetQua', url)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="text-right mt-3">
                                <Button variant="secondary" className="mr-2" onClick={() => setViewMode('list')} disabled={isSubmitting}>
                                    Hủy
                                </Button>
                                <Button variant="primary" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? 'Đang lưu...' : 'Lưu lại'}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default HocPhanBoSungAdd;
